module.exports = __webpack_public_path__ + "img/f64.1692b586.png";